import axios from 'axios'

export default {
    register(data) {
        return axios.post('/auth/register', data)
    },

    verifyEmail(data) {
        return axios.post('/auth/verify-account', data)
    },

    confirmEmailChange(data) {
        return axios.post('/auth/confirm-email-change', data)
    },

    login(data) {
        return axios.post('/auth/login', data)
    },

    resendVerificationEmail(data) {
        return axios.post('/auth/resend-verification-email', data)
    },

    logout(data) {
        return axios.post('/auth/logout', data)
    },

    refreshToken(data) {
        return axios.post('/auth/refresh', data)
    },

    forgotPassword(data) {
        return axios.post('/auth/forgot-password', data)
    },

    resetPassword(data) {
        return axios.post('/auth/reset-password', data)
    },

    loginGoogle(data) {
        return axios.post('/auth/login-google', data)
    },

    loginGoogleOneTap(data) {
        return axios.post('/auth/login-google-onetap', data)
    },

    loginFacebook(data) {
        return axios.post('/auth/login-facebook', data)
    },

    loginApple(data) {
        return axios.post('/auth/login-apple', data)
    },

    support(data) {
        return axios.post('/support', data)
    },

    subdomainSupport(data, id) {
        return axios.post('support/company', data, {
            headers: {
                'x-tenant-id': id,
            },
        })
    },

    getClientData(data) {
        return axios.post('/auth/finalize-account-info', data)
    },

    finalizeAccount(data) {
        return axios.post('/auth/finalize-account', data)
    },
}
